import React from 'react';
import { CodeTab } from '../../dag-detail/code-tab';

type RunCodeTabProps = {
    dagId: string;
    refreshKey: number;
};

/*
 * Thin wrapper reusing the DAG detail Code tab, scoped to this run's DAG (no run-level
 * parse metadata to show, since a run doesn't carry DAG parse-time fields)
 */
export function RunCodeTab({ dagId, refreshKey }: RunCodeTabProps) {
    return <CodeTab dagId={dagId} details={null} isLoadingDetails={false} refreshKey={refreshKey} />;
}
